import React, { useEffect, useState } from "react";
import Axios from "axios";
import { useNavigate } from "react-router-dom";

function UserSavings() {
  const mobile_no = localStorage.getItem("userMobile");
  const [savings, setSavings] = useState([]);
  const userSHG = localStorage.getItem("userSHG");
  const token = localStorage.getItem("userToken");

  const navigate = useNavigate();

  useEffect(() => {
    checkSHG();
  }, []);

  const checkSHG = () => {
    if (!localStorage.getItem("userSHG")) {
      navigate("/userSelectSHG");
    }
  };
  useEffect(() => {
    Axios.post(
      "https://us-east4-safechama.cloudfunctions.net/getmembersavings",
      { message: { access_token: token, mobile_no: mobile_no } },
      {
        headers: { "Content-Type": "application/json" },
      }
    )
      .then((res) => {
        // console.log("GEtting DAta From::", res.data.data);
        setSavings(res.data.data);
      })
      .catch((err) => console.log(err));
  }, []);
  const mySavings = Object.values(savings);
  const dataSavings = mySavings.map((data, index) => {
    return (
      <tr key={index}>
        <td>
          <input
            type="checkbox"
            className="form-checkbox w-4 h-4 text-indigo-500 border border-gray-300 rounded dark:bg-gray-700 dark:border-gray-700"
          />
        </td>
        <td>
          <div className="flex flex-wrap flex-row items-center">
            <i className="fas fa-users"></i>
          </div>
        </td>
        <td>{data.mobile_no}</td>
        <td>{data.account_name} </td>
        <td>{data.amount} </td>
        <td>{data.date_deposited}</td>

        <td>
          <span className="text-sm px-2 py-1 font-semibold leading-tight text-green-700 bg-green-100 rounded-full">
            Active
          </span>
        </td>
      </tr>
    );
  });

  return (
    <>
      <main className="pt-20 -mt-2">
        <div className="mx-auto p-2">
          <div className="flex flex-wrap flex-row">
            <div className="flex-shrink max-w-full px-4 w-full">
              <p className="text-xl font-bold mt-3 mb-5 dark:text-gray-200">
                User's Savings on {userSHG}
              </p>
            </div>
            <div className="flex-shrink max-w-full px-4 w-full mb-6">
              <div className="p-6 bg-white dark:bg-gray-800 rounded-lg shadow-lg h-full">
                <div className="flex flex-wrap flex-row -mx-4">
                  <div className="flex-shrink max-w-full px-4 w-full">
                    <div className="w-full mb-6 overflow-x-auto">
                      <table className="table-sorter table-bordered w-full text-left text-gray-600 dark:text-gray-400">
                        <thead>
                          <tr className="bg-gray-100 dark:bg-gray-900 dark:bg-opacity-40">
                            <th data-sortable="false">
                              <input
                                id="check_all"
                                type="checkbox"
                                className="form-checkbox w-4 h-4 text-indigo-500 border border-gray-300 rounded dark:bg-gray-700 dark:border-gray-700"
                              />
                            </th>
                            <th>Image</th>
                            <th>User Mobile</th>
                            <th>SHG Name</th>
                            <th> Amount (KES) </th>
                            <th className="hidden lg:table-cell">Date added</th>
                            <th className="hidden lg:table-cell">Status</th>
                          </tr>
                        </thead>
                        <tbody>{dataSavings}</tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default UserSavings;
